import { Badge } from '@/components/ui/Badge';
import {
  TICKET_STATUS_LABELS, PRIORITY_LABELS,
  type TicketStatus, type Priority,
} from '@/types/production';

const STATUS_TONES: Record<TicketStatus, 'neutral' | 'info' | 'warning' | 'success' | 'danger' | 'brass'> = {
  draft:       'neutral',
  queued:      'info',
  in_progress: 'brass',
  blocked:     'warning',
  complete:    'success',
  cancelled:   'danger',
};

const PRIORITY_TONES: Record<Priority, 'neutral' | 'info' | 'warning' | 'danger'> = {
  low:    'neutral',
  normal: 'info',
  high:   'warning',
  rush:   'danger',
};

export function TicketStatusBadge({ status }: { status: TicketStatus }) {
  return <Badge tone={STATUS_TONES[status]}>{TICKET_STATUS_LABELS[status]}</Badge>;
}

export function PriorityBadge({ priority }: { priority: Priority }) {
  if (priority === 'normal') return null; // don't clutter with the default
  return <Badge tone={PRIORITY_TONES[priority]}>{PRIORITY_LABELS[priority]}</Badge>;
}
